<template>
  <div class="service">
    <div class="info serviceInfo flexBetween">
      <div class="service-left">
        <div class="indexTitle">
          <p class="flexItems"><span></span>服务</p>
          <p>Service</p>
        </div>
        <div class="service-left-text">
          <p>国内互联网航运交易平台</p>
          <p>海量货主</p>
          <p>与内河船东<span>入驻</span></p>
        </div>
        <div class="service-left-img">
          <img src="../../static/img/fw.jpg" alt="" />
        </div>
      </div>
      <zmlservicebanner></zmlservicebanner>
    </div>

    <!-- 移动端 -->
    <div class="phone-service">
      <div class="indexTitle">
        <p class="flexItems"><span></span>服务</p>
        <p>Service</p>
      </div>
      <div class="phone-service-swiper">
        <swiper ref="mySwiper1" :options="swiperOptions1">
          <swiper-slide>
            <img src="../../static/img/pro4.2.jpg" alt="" />
          </swiper-slide>
          <swiper-slide>
            <img src="../../static/img/pro3.jpg" alt="" />
          </swiper-slide>
          <swiper-slide>
            <img src="../../static/img/pro2.2.jpg" alt="" />
          </swiper-slide>
          <div
            class="swiper-pagination phone-service-page"
            slot="pagination"
          ></div>
        </swiper>
      </div>
      <div class="content flexCenter flexItems">
        <div class="service-left-text">
          <p>国内互联网航运交易平台</p>
          <p>海量货主</p>
          <p>与内河船东<span>入驻</span></p>
        </div>
        <div class="phone-service-text">
          <p>7x24小时专属客服+运单状态完全展示，</p>
          <p>您的专属航运大管家！</p>
        </div>
      </div>
    </div>

    <span class="zmldown2"></span>
  </div>
</template>
<script>
import zmlservicebanner from "@/components/serviceBanner.vue";
export default {
  data() {
    return {
      swiperOptions1: {
        autoplay: {
          delay: 1500,
          disableOnInteraction: false,
        },
        speed: 1500,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
    };
  },
  components: {
    zmlservicebanner,
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper1.$swiper;
    },
  },
};
</script>
<style scoped="scoped">
/* 服务 */

.service {
  width: 100%;
  height: 100%;
  background-color: #f7faff;
}

.serviceInfo {
  padding-top: 125px;
}

.service-left {
  width: 535px;
  height: 100%;
}

.service-left-text {
  margin-top: 100px;
}

.service-left-text > p:nth-of-type(1) {
  font-size: 28px;
  color: #343434;
}

.service-left-text > p:nth-of-type(2) {
  font-size: 54px;
  color: #282828;
  margin-top: 10px;
}

.service-left-text > p:nth-of-type(3) {
  font-size: 54px;
  color: #282828;
}

.service-left-text > p:nth-of-type(3) span {
  color: #127bfd;
}

.service-left-img {
  width: 100%;
  height: 384px;
  overflow: hidden;
  margin-top: 50px;
}

.service-left-img img {
  width: 100%;
}

@media only screen and (max-width: 1600px) {
  .service-left {
    width: 50%;
    padding-right: 20px;
  }
  .service-left-text {
    margin-top: 30px;
  }
  .service-left-text > p:nth-of-type(2),
  .service-left-text > p:nth-of-type(3) {
    font-size: 30px;
  }
  .service-left-img {
    overflow: hidden;
    height: 50%;
    display: flex;
    display: -ms-flexbox;
    align-items: center;
    justify-content: center;
  }
}

@media only screen and (max-width: 750px) {
  .serviceInfo {
    padding-top: 0;
    display: none;
  }
  .phone-service {
    height: 100%;
    display: flex;
    flex-flow: column;
  }
  .phone-service-swiper {
    width: 100%;
  }
  .phone-service-swiper .swiper-slide img {
    width: 100%;
  }
  .phone-service .service-left-text {
    margin-top: 0px;
    text-align: center;
    font-weight: bold;
  }
  .phone-service .service-left-text > p:nth-of-type(1) {
    font-size: 20px;
    font-weight: bold;
  }
  .phone-service .service-left-text > p:nth-of-type(2) {
    font-size: 40px;
  }
  .phone-service .service-left-text > p:nth-of-type(3) {
    font-size: 40px;
  }
  .phone-service-text {
    font-size: 16px;
    text-align: center;
    font-weight: bold;
    line-height: 30px;
    margin-top: 50px;
  }
  .phone-service-page {
    display: flex;
    align-items: center;
    justify-content: center;
    bottom: 10px;
  }
  .phone-service-page >>> .swiper-pagination-bullet {
    opacity: 1;
    background-color: #fff;
    outline: none;
  }
  .phone-service-page >>> .swiper-pagination-bullet-active {
    width: 12px;
    height: 12px;
    opacity: 1;
    background: url(../../static/img/active-point.png) no-repeat center;
    background-size: cover;
  }
  .content {
    flex: 1;
    flex-flow: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index_service.vue